import { ref, watch } from "vue";
import { useStore } from "vuex";
import debounce from "../../foundation/js/deBounce";

import { dataLayerAddToCart } from "../../foundation/js/dataLayerHelpers";

export default {
  name: "QuickOrder",
  setup() {
    const store = useStore();
    const amount = ref(1);
    const variantSku = ref(null);
    const disableButton = ref(false);
    const getLabel = (labelRequested) => {
      return store.getters['labels/getLabel'](labelRequested)
    }
    const addSuccess = ref(true);
    watch(variantSku,()=>{
      addSuccess.value = true;
    });

    const addToCart = debounce(function () {
      disableButton.value = true;
      store
        .dispatch("ecom/tryAddToCartByVariantSku", {
          variantSku: variantSku.value,
          quantity: amount.value,
        })
        .then((status) => {
          addSuccess.value = status;
          disableButton.value = false;
          amount.value = status ? 1 : amount.value;
          variantSku.value = status ? null : variantSku.value;
          if(status) store.dispatch('ecom/getCart')});
    }, 400);

    return {
      addToCart,
      getLabel,
      variantSku,
      amount,
      disableButton,
      addSuccess
    };
  },
};
